import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=a6373c78&scoped=true"
import script from "./Recording.vue?vue&type=script&lang=js"
export * from "./Recording.vue?vue&type=script&lang=js"
import style0 from "./Recording.vue?vue&type=style&index=0&id=a6373c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6373c78",
  null
  
)

export default component.exports